// Utilities
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

// Service

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";

// Types
import { teamMemberService } from "../../../../../Api/Services/TeamMembers";
import {
  ITeamMembersLeaveListParams,
  ITeamMembersLeaveServiceResponse,
} from "../../types";

/**
 * Async thunk to handle fetch team members leave.
 * Dispatches an API call to the team members leave service.
 */
export const fetchTeamMembersLeaveAsyncThunk = createServiceAsyncThunk<
  ITeamMembersLeaveServiceResponse, // Response Type
  ITeamMembersLeaveListParams // Payload Type
>(
  ACTION_NAMES.FETCH_TEAM_MEMBERS_LEAVE, // Action Name
  ({ user, activeYear, type, status }) =>
    teamMemberService.fetchTeamMembersLeave(user, activeYear, type, status), // API Call
  ERROR_MESSAGES.TEAM_MEMBERS_LEAVE_LIST_FETCH_FAILURE // Error Message
);

/**
 * Slice to manage the state for team members leave.
 * Includes actions to clear errors and handle async states.
 */
export const teamMembersLeaveListSlice = createGenericSlice<
  ITeamMembersLeaveServiceResponse, // Response Type
  ITeamMembersLeaveListParams // Payload Type
>(SLICE_NAMES.TEAM_MEMBERS_LEAVE, fetchTeamMembersLeaveAsyncThunk);

// Exporting the action to reset the error state
export const { clearError: clearTeamMembersLeaveListError } =
  teamMembersLeaveListSlice.actions;

// Exporting the reducer to be used in the store
export default teamMembersLeaveListSlice.reducer;

